import { useEffect, useState } from "react";
import "./complaint.css";
import { getComplaintsData } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import Pagination from "./Pagination";
import HeaderTableComplaint from "./HeaderTableComplaints";
import { FaEye } from "react-icons/fa";

const toISO = (d) => (d instanceof Date ? d.toISOString() : undefined);
function ApproveComplaints() {
  let token = useSelector((store) => store.userReducer.token);
  let role = useSelector((store) => store.userReducer.role);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [pagesData, setPagesData] = useState(0);
  const [startDate, setStartDate] = useState(() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  });

  const [endDate, setEndDate] = useState(() => {
    const d = new Date();
    d.setHours(23, 59, 59, 999);
    return d;
  });
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (!token) return;

    const fetchComplaints = async () => {
      const response = await getComplaintsData(
        token,
        currentPage,
        toISO(startDate),
        toISO(endDate),
         selectedUserId
      );

      setPagesData(response.meta?.pagination?.totalPages || 0);
      setAckRows(groupByAckNo(response.data || []));
    };

    fetchComplaints();
  }, [token, currentPage, startDate, endDate,selectedUserId]);

  const groupByAckNo = (complaints) => {
    const map = {};

    complaints.forEach((item) => {
      if (!map[item.ackNo]) {
        map[item.ackNo] = {
          ackNo: item.ackNo,
          utrs: [],
        };
      }

      map[item.ackNo].utrs.push({
        ...item,
        isEditing: false,
      });
    });

    return Object.values(map);
  };

  const [ackRows, setAckRows] = useState([]);

  return (
    <div className="complaint-container">
<HeaderTableComplaint
  setParentStartDate={setStartDate}
  setParentEndDate={setEndDate}
  setParentUserId={setSelectedUserId}
  currentPage={currentPage}
/>


      {ackRows.length === 0 ? (
        <div className="empty-state">
          <h3>No complaints found</h3>
        </div>
      ) : (
        ackRows.map((ack, ackIndex) => (
          <div key={ack.ackNo} className="ack-block">
            <h4>Acknowledgement No: {ack.ackNo}</h4>

            <table className="complaint-table">
              <thead>
                <tr>
                  {role !== "admin" && <th>Merchant</th>}
                  <th>Order ID</th>
                  <th>UTR</th>
                  <th>Amount</th>
                  <th>Fees</th>
                  <th>Txn Date</th>
                  <th>Complaint Date</th>
                  <th>Uploaded Date</th>
                  <th>View</th>
                </tr>
              </thead>

              <tbody>
                {ack.utrs.map((row, utrIndex) => (
                  <tr key={row.id}>
                    {role !== "admin" && <td>{row.merchantName}</td>}
                    <td>{row.orderId}</td>
                    <td>{row.utr}</td>
                    <td>₹ {row.amount}</td>

                    <td>₹ {row.fees ? row.fees : "0.00"}</td>
                    <td>
                      {row.createdAt
                        ? new Date(row.createdAt).toLocaleDateString("en-GB")
                        : "-"}
                    </td>

                    <td>
                      {row.complaintDate
                        ? new Date(row.complaintDate).toLocaleDateString(
                            "en-GB",
                          )
                        : "-"}
                    </td>

                    <td>
                      {row.updatedAt
                        ? new Date(row.updatedAt).toLocaleDateString("en-GB")
                        : "-"}
                    </td>
                    <td>
                      <FaEye
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedRow(row);
                          setShowModal(true);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}

      {showModal && selectedRow && (
        <div className="modal-overlay">
          <div className="modal-card">
            <div className="modal-top">
              <div>
                <h2>Complaint Details</h2>
                <span className="subtext">ACK #{selectedRow.ackNo}</span>
              </div>

              <button
                className="modal-close"
                onClick={() => setShowModal(false)}
              >
                ✕
              </button>
            </div>

            <div className="modal-body">
              <div className="info-grid">
                {role !== "admin" && (
                  <div>
                    <label>Merchant</label>
                    <span>{selectedRow.merchantName}</span>
                  </div>
                )}

                <div>
                  <label>Order ID</label>
                  <span>{selectedRow.orderId}</span>
                </div>

                <div>
                  <label>UTR</label>
                  <span>{selectedRow.utr}</span>
                </div>

                <div>
                  <label>Amount</label>
                  <span>₹ {selectedRow.amount}</span>
                </div>

                <div>
                  <label>Fees</label>
                  <span>₹ {selectedRow.fees || "0.00"}</span>
                </div>

                <div>
                  <label>VPA</label>
                  <span>{selectedRow.vpa || "-"}</span>
                </div>
              </div>

              <hr />

              <div className="info-grid">
                <div>
                  <label>Payer Name</label>
                  <span>{selectedRow.customerName || "-"}</span>
                </div>

                <div>
                  <label>Payer Email</label>
                  <span>{selectedRow.email || "-"}</span>
                </div>

                <div>
                  <label>Payer Phone</label>
                  <span>{selectedRow.phone || "-"}</span>
                </div>
                <div>
                  <label>Complainter Name</label>
                  <span>{selectedRow.complainterName || "-"}</span>
                </div>
                <div>
                  <label>Complainter Phone</label>
                  <span>{selectedRow.complainterPhone || "-"}</span>
                </div>
              </div>

              <hr />

              <div className="info-grid">
                <div>
                  <label>Transaction Date</label>
                  <span>
                    {selectedRow.createdAt
                      ? new Date(selectedRow.createdAt).toLocaleDateString(
                          "en-GB",
                        )
                      : "-"}
                  </span>
                </div>

                <div>
                  <label>Complaint Date</label>
                  <span>
                    {selectedRow.complaintDate
                      ? new Date(selectedRow.complaintDate).toLocaleDateString(
                          "en-GB",
                        )
                      : "-"}
                  </span>
                </div>

                <div>
                  <label>Last Updated</label>
                  <span>
                    {selectedRow.updatedAt
                      ? new Date(selectedRow.updatedAt).toLocaleDateString(
                          "en-GB",
                        )
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pagesData={pagesData}
      />
    </div>
  );
}

export default ApproveComplaints;
